import { Component, inject, Input } from '@angular/core';
import { CommonModule, KeyValue } from '@angular/common';
import { Observable } from 'rxjs';
import {
  AlignmentEnum,
  HomepageHero,
  ImageFetchPriority,
  ImageLoadingStrategy,
  SearchOption,
  SearchOptions,
} from '@boels/models';
import { CustomSearchBoxComponent } from '../custom-searchbox/custom-searchbox.component';
import {
  TRANSLOCO_SCOPE,
  TranslocoModule,
  TranslocoService,
} from '@jsverse/transloco';
import { BreakpointService, QaHooksDirective } from '@boels/helpers';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { StoreFinderSearchComponent } from '../store-finder/store-finder-search/store-finder-search.component';
import { take } from 'rxjs/operators';
import { VerticalAlignerComponent } from '../vertical-aligner/vertical-aligner.component';
import { MediaComponent } from '../media/media.component';

@Component({
  selector: 'boels-homepage-hero',
  templateUrl: './homepage-hero.component.html',
  styleUrls: ['./homepage-hero.component.scss'],
  imports: [
    MediaComponent,
    CommonModule,
    CustomSearchBoxComponent,
    TranslocoModule,
    FontAwesomeModule,
    StoreFinderSearchComponent,
    QaHooksDirective,
    VerticalAlignerComponent,
  ],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: ['homepageSearch', 'header'],
    },
  ],
})
export class HomepageHeroComponent {
  #translocoService = inject(TranslocoService);
  #breakpointService = inject(BreakpointService);

  @Input() componentData: { data$: Observable<HomepageHero> };
  public alignment = AlignmentEnum;
  public ImageLoadingStrategy = ImageLoadingStrategy;
  public ImageFetchPriority = ImageFetchPriority;
  hasSearchResults = false;
  faSearch = faSearch;

  search: boolean;
  SearchOption = SearchOption;
  activeOption: string = SearchOption.PRODUCT; // initially active product search
  isMobile: Observable<boolean> = this.#breakpointService.xs$;

  searchTerm: string;
  availableOptionLabels: SearchOptions = {
    [SearchOption.PRODUCT]: 'homepageSearch.label.productSelectLabel',
    [SearchOption.BRANCHES]: 'homepageSearch.label.branchSelectLabel',
  };

  $searchButtonTextToSpeech = this.#translocoService
    .selectTranslate('textToSpeech.search')
    .pipe(take(1));

  callSearch(): void {
    this.search = true;
  }

  updateSearchTerm(value: string): void {
    this.searchTerm = value;
  }

  onSearchChange(hasResults: boolean): void {
    this.hasSearchResults = hasResults;
  }

  changeOption(option: Event): void {
    const optionTarget = option.target as HTMLInputElement;
    this.activeOption = optionTarget.value;
    this.search = false;
  }

  trackByKey(index: number, option: KeyValue<string, string>): string {
    return option.key;
  }
}
